var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pen-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53856 2.76546C10.5592 1.74485 12.2139 1.74485 13.2346 2.76546C14.2552 3.78607 14.2552 5.44081 13.2346 6.46142L7.94044 11.7555C7.63798 12.058 7.45988 12.2361 7.2618 12.3906C7.02838 12.5727 6.77574 12.7288 6.50846 12.8562C6.28168 12.9642 6.04279 13.0439 5.63696 13.1791L3.77773 13.7989L3.33006 13.9481C2.96696 14.0691 2.56663 13.9746 2.29599 13.704C2.02535 13.4334 1.93085 13.033 2.05188 12.6699L2.82084 10.363C2.95611 9.95722 3.03573 9.71833 3.1438 9.49156C3.27119 9.22427 3.42731 8.97166 3.60942 8.73819C3.76391 8.5401 3.94198 8.36206 4.24448 8.05955L9.53856 2.76546ZM3.75842 12.9228L5.34438 12.3942C5.78593 12.247 5.97354 12.1837 6.14827 12.1004C6.36067 11.9992 6.5614 11.8752 6.74693 11.7304C6.89957 11.6114 7.04005 11.4719 7.36918 11.1428L11.594 6.91798C11.1538 6.76272 10.5867 6.47495 10.0559 5.94409C9.52505 5.41323 9.23727 4.84617 9.08206 4.406L4.85721 8.6308C4.5281 8.95994 4.38861 9.10042 4.26956 9.25307C4.12486 9.43859 4.00079 9.6393 3.89958 9.85173C3.8163 10.0264 3.753 10.2141 3.60582 10.6556L3.07716 12.2416L3.75842 12.9228ZM9.76114 3.7269C9.78023 3.82456 9.81249 3.9573 9.8663 4.11248C9.98752 4.46186 10.2165 4.92067 10.6479 5.3521C11.0793 5.78352 11.5381 6.01248 11.8875 6.13369C12.0427 6.18753 12.1754 6.21979 12.2731 6.23887L12.6425 5.86942C13.3362 5.17576 13.3362 4.05112 12.6425 3.35745C11.9489 2.66379 10.8242 2.66379 10.1306 3.35745L9.76114 3.7269Z",
    fill: "#535353"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/Editicon.f618417d31828b232e9d256e4f68200c.svg";
export { ForwardRef as ReactComponent };